import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';

import { CognitoService } from './cognito.service';
import { UsersService } from '../pages/users/users.service';
import { APIService, GetUserQuery, User } from '../app-sync.service';
import { CognitoUser } from '../shared/interfaces/cognito-user';
import { FeedbacksService } from '../shared/feedbacks/feedbacks.service';

@Injectable({
  providedIn: 'root',
})
export class ActiveUserResolver implements Resolve<User | null> {
  private activeCognitoUser: CognitoUser | null = null;

  constructor(
    private cognitoService: CognitoService,
    private usersService: UsersService,
    private api: APIService,
    private feedbacksService: FeedbacksService,
    private router: Router
  ) {}

  async resolve(): Promise<User | null> {
    try {
      // si ya existe el usuario no volver a pedirlo
      const existingUser = this.usersService.getActiveUser();
      if (existingUser.hasAccessTo) {
        return existingUser;
      }

      const cognitoUser: any = await this.cognitoService.getUser();
      this.activeCognitoUser = cognitoUser.attributes;

      const user: GetUserQuery = await this.api.GetUser(
        this.activeCognitoUser!.email
      );

      // guardar en UsersService
      this.usersService.setActiveUser(user);

      return user;
    } catch (response: any) {
      if (response?.errors) {
        this.feedbacksService.showErrorFeedbacks(
          response,
          `Error al cargar datos del usuario`
        );
      }

      // opcional redirigir
      this.router.navigate(['/home']);

      return null;
    }
  }
}
